import type { PayLetterPaymentMethod } from '../../../domains/orders/services/orderServices';

export const PAY_LETTER_PAYMENT_METHOD_OPTIONS: Array<{
  value: PayLetterPaymentMethod;
  label: string;
  subLabel: string;
  buttonClassName: string;
  badgeClassName: string;
}> = [
  {
    value: 'creditcard',
    label: '신용카드',
    subLabel: 'CARD',
    buttonClassName:
      'bg-[linear-gradient(135deg,#2563EB_0%,#1D4ED8_100%)] text-white border-transparent',
    badgeClassName: 'bg-white/18 text-white'
  },
  {
    value: 'kakaopay',
    label: '카카오페이',
    subLabel: 'KAKAO PAY',
    buttonClassName: 'bg-[#FEE500] text-[#191919] border-[#E6CF00]',
    badgeClassName: 'bg-black/10 text-[#191919]'
  },
  {
    value: 'payco',
    label: '페이코',
    subLabel: 'PAYCO',
    buttonClassName:
      'bg-[linear-gradient(135deg,#EF4444_0%,#DC2626_100%)] text-white border-transparent',
    badgeClassName: 'bg-white/18 text-white'
  },
  {
    value: 'checkpay',
    label: '체크페이',
    subLabel: 'CHECKPAY',
    buttonClassName:
      'bg-[linear-gradient(135deg,#22C55E_0%,#16A34A_100%)] text-white border-transparent',
    badgeClassName: 'bg-white/18 text-white'
  },
  {
    value: 'toss',
    label: '토스',
    subLabel: 'TOSS',
    buttonClassName:
      'bg-[linear-gradient(135deg,#3182F6_0%,#0064FF_100%)] text-white border-transparent',
    badgeClassName: 'bg-white/18 text-white'
  },
  {
    value: 'ssgpay',
    label: 'SSG페이',
    subLabel: 'SSGPAY',
    buttonClassName:
      'bg-[linear-gradient(135deg,#F97316_0%,#EA580C_100%)] text-white border-transparent',
    badgeClassName: 'bg-white/18 text-white'
  },
  {
    value: 'naverpay',
    label: '네이버페이',
    subLabel: 'NAVER PAY',
    buttonClassName:
      'bg-[linear-gradient(135deg,#03C75A_0%,#00B050_100%)] text-white border-transparent',
    badgeClassName: 'bg-white/18 text-white'
  },
  {
    value: 'samsungpay',
    label: '삼성페이',
    subLabel: 'SAMSUNG PAY',
    buttonClassName:
      'bg-[linear-gradient(135deg,#2436B8_0%,#1428A0_100%)] text-white border-transparent',
    badgeClassName: 'bg-white/18 text-white'
  },
  {
    value: 'applepay',
    label: '애플페이',
    subLabel: 'APPLE PAY',
    buttonClassName:
      'bg-[linear-gradient(135deg,#1F2937_0%,#000000_100%)] text-white border-transparent',
    badgeClassName: 'bg-white/18 text-white'
  }
];
